import { useState } from "react";

function Counter() {
    let [ count, setCount ] = useState(0)
    return (
        <div>
            <button className="btn btn-large" 
                    style={{color:"black", width: "60px"}}
                    onClick={()=>setCount(()=> --count)}
            >
                -1
            </button>
            <span style={{fontSize:"40px", margin: "10px"}}>{count}</span>
            <button className="btn btn-large" 
                    style={{color:"black", width: "60px"}}
                    onClick={()=>setCount(()=> ++count)}
            >
                +1
            </button>
        </div>
    );
}
  
export default Counter;